import request from "root/js/request";

export const postProductCostValidator = async ({ formData, wb_api_key_id }) => {
  const token = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");

  formData.append("wb_api_key_id", wb_api_key_id);

  const response = await request({
    url: `/analytics/product_cost_validator/`,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${token}`,
    },
  });
  return response.data;
};
